import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * AnalyticsTracker component listens to route transitions and logs pageviews in GA.
 * It must be rendered inside the Router context in App.js.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Record pageview when location pathname or search changes
    const pagePath = location.pathname + location.search;
    trackPageView(pagePath, document.title);
  }, [location]);

  return null; // Side-effect only component
};

export default AnalyticsTracker;
